<template>
  <b-container class="tx_class">
    <b-row style="justify-content: space-around">
      <b-col cols=4 class="tx_class_col"><AccountLink v-bind:account="account" /></b-col>
      <b-col cols=4 v-bind:style="{color: color}" style="text-align: center">[{{msg}}]</b-col>
      <b-col cols=4 class="tx_class_col"><LimitAmount v-bind:amount="limit_amount" /></b-col>
    </b-row>
  </b-container>
</template>

<script>
import AccountLink from '../AccountLink.vue'
import LimitAmount from '../LimitAmount.vue'

var HasTx = require('../../mixins/has_tx')

export default {
  name   : 'TrustSetTx',

  mixins : [HasTx],

  components : {
    AccountLink,
    LimitAmount
  },

  computed : {
    account : function(){
      return this.tx_obj["Account"];
    },

    limit_amount : function(){
      return this.tx_obj["LimitAmount"];
    },

    msg : function(){
      return this.limit_amount.value == 0 ? 'revoked trust' : 'extended trust';
    },

    color : function(){
      return this.limit_amount.value == 0 ? 'red' : 'green';
    }
  }
}
</script>

<style scoped>
</style>
